export const isMobile = state => state.browser.lessThan.medium;

export const isLarge = state => state.browser.lessThan.infinity;



// WEBPACK FOOTER //
// ./src/selectors/browser.js